import FormaPagamentoNovo from './FormaPagamentoNovo';

export default FormaPagamentoNovo;